import React from 'react';
import { NavLink } from 'react-router-dom';
import './SideNav.css';
// import './SideNavRtl.css';

const ContentNav = ({ language }) => {
    return (
        <React.Fragment>
            <ul>
                <li>
                    <NavLink to="/content" activeClassName="activeTabNav">
                        <span className="imgLink">
                            <img src="/images/darkblue24icons/orders.png" alt="dashboard" />
                        </span>
                        <span className="txtLink">{language.manage_content}</span>
                    </NavLink>
                </li>
                <li>
                    <NavLink to="/questionnaire" activeClassName="activeTabNav">
                        <span className="imgLink">
                            <img src="/images/blue/questionnaire.png" alt="questionnaire" className='invertPrimary' />
                        </span>
                        <span className="txtLink">{language.questionnaire}</span>
                    </NavLink>
                </li>
                {true && // This condition can be modified based on your needs
                <li>
                    <NavLink to="/assignments" activeClassName="activeTabNav">
                        <span className="imgLink">
                            <img src="/images/blue/assignment.png" alt="assignment" className='invertPrimary' />
                        </span>
                        <span className="txtLink">{language.assignments}</span>
                    </NavLink>
                </li>
                }
                <li>
                    <NavLink to="/uploads" activeClassName="activeTabNav">
                        <span className="imgLink">
                            <img src="/images/blue/upload-doc.png" alt="dashboard" className='invertPrimary' />
                        </span>
                        <span className="txtLink">{language.crteContent_upload_document}</span>
                    </NavLink>
                </li>
            </ul>
        </React.Fragment>
    );
}

export default ContentNav;